


































































import { defineComponent } from '@nuxtjs/composition-api';
import { ModalDialog, TypeBody } from '@bambeehr/pollen';

export default defineComponent({
  name: 'GlowModal',
  components: {
    ModalDialog,
    TypeBody,
  },
  props: {
    /**
     * Main title text
     */
    title: {
      type: String,
      default: undefined,
    },
    /**
     * Subtitle text displayed above the title
     */
    subtitle: {
      type: String,
      default: undefined,
    },
  },
});
